import { createContext, useContext, type ReactNode } from "react";
import { createPortal } from "react-dom";

// Lets the routed page render the open file's name + save status inside the
// shell's top bar (SuiteAppBar's title region).

export const ShellHeaderContext = createContext<HTMLElement | null>(null);

export function ShellHeaderPortal({ children }: { children: ReactNode }) {
    const slot = useContext(ShellHeaderContext);
    return slot ? createPortal(children, slot) : null;
}
